module.exports = __webpack_public_path__ + "static/media/page-break.54493b0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/page-break.svg
// module id = 3262
// module chunks = 7